<template>
  <div :class="classes">
    <!-- <label
      class="asd20-select-input__label"
      v-show="!hideLabel"
      v-html="label"
    /> -->
    <div class="asd20-select-input__field-wrapper">
      <slot name="prefix" />
      <Asd20Icon v-show="icon" :name="icon" />
      <div class="asd20-select-input__select-wrapper">
        <select
          :value="value"
          v-bind="$attrs"
          :id="computedId"
          v-on="listeners"
          @input="input"
          :aria-label="hideLabel ? label : ''"
        >
          <option
            v-if="itemDefault"
            :selected="itemDefault[itemValue] === value ? 'selected' : ''"
            :value="itemDefault[itemValue]"
            v-html="itemDefault[itemLabel]"
          />
          <option
            v-for="item in computedItems"
            :key="item[itemValue]"
            :value="item[itemValue]"
            :selected="item[itemValue] === value ? 'selected' : ''"
            v-html="item[itemLabel]"
          />
        </select>
        <label
          class="asd20-select-input__overlay-label"
          :for="computedId"
          v-html="selectedItemLabel"
        />
      </div>
    </div>
    <div
      class="asd20-select-input__help-text"
      v-show="helpText"
      v-html="helpText"
    />
    <div
      class="asd20-select-input__validation-error"
      v-for="(v, index) in validationErrors"
      :key="index"
      v-html="v"
    />
  </div>
</template>

<script>
import inputComponentMixin from '../../../mixins/inputComponentMixin'
import Asd20Icon from '../../atoms/Asd20Icon'
export default {
  name: 'Asd20SelectInput',
  mixins: [inputComponentMixin],
  components: { Asd20Icon },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';
@import '../../../design/_mixins.scss';

$input-border-width: 2px;
$input-border-color: var(--color__accent);
$input-background-color: var(--website-page__background-color);
$input-background-color-hover: var(--website-page__alternate-background-t40);
$input-accent-color: var(--color__accent);
$input-text-color: var(--website-card__reverse-background-color);

$input-reversed-border-color: var(--color__tertiary);
$input-reversed-background-color: var(--color__primary);
$input-reversed-background-color-hover: var(--color__primary-s20);
$input-reversed-accent-color: var(--color__accent);
$input-reversed-text-color: var(--color__accent-t100);

.asd20-select-input {
  position: relative;
  color: $input-text-color;
  margin-bottom: space(0.5);
  &__overlay-label {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    font-size: 1em;
    font-weight: normal;
    font-family: Ariel, Arial, Helvetica, sans-serif;
    border-radius: 2px;
    cursor: pointer;
    color: var(--website-page__foreground-color);
    padding: space(0.25) space(0.5);
    height: space(1.25);
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    // box-shadow: 0 0 0 $input-border-width $input-border-color inset;
    margin: 0 0 0 0;

    &::after {
      content: '';
      pointer-events: none;
      display: block;
      width: 0;
      height: 0;
      margin-left: space(0.5);
      margin-top: space(0.25);
      transform: rotate(90deg);
      border: space(0.25) solid transparent;
      border-left-color: $input-border-color;
    }
  }
  select {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    opacity: 0;
    background: rgba(255, 255, 255, 0.9);
    width: 100%;
    cursor: pointer;
    &:focus ~ label {
      @include asd20-focus;
    }
  }

  &__field-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__select-wrapper {
    flex-grow: 1;
  }

  // Icon colors
  use {
    --line-color: #{$input-text-color};
    --fill-color: #{$input-accent-color};
  }

  &__label {
    color: var(--website-page__foreground-color);
  }

  &__field-wrapper {
    transition: background asd20-speed(1) ease-in-out;
    // background: $input-background-color;
    color: currentColor;
  }

  &--reversed {
    // color: $input-reversed-text-color;
    color: var(--website-header__foreground-color);
    // color: pink;
    svg {
      --line-color: #{$input-reversed-border-color};
      --fill-color: #{$input-reversed-accent-color};
    }
    .asd20-select-input__field-wrapper {
      // background: $input-reversed-background-color;

      .asd20-select-input__overlay-label::after {
        // border-left-color: $input-reversed-text-color;
        border-left-color: $input-reversed-accent-color;
      }
    }

    &.asd20-select-input--transparent .asd20-select-input__field-wrapper:hover,
    &.asd20-select-input--transparent .asd20-select-input__field-wrapper:focus {
      background-color: rgba(black, 0.25);
    }

    &.asd20-select-input--bordered .asd20-select-input__field-wrapper {
      box-shadow: 0 0 0 $input-border-width $input-reversed-accent-color inset;
    }
  }
  &--transparent {
    .asd20-select-input__field-wrapper {
      background: transparent;
    }
    .asd20-select-input__overlay-label {
      // padding: space(0.5) 0;
    }
    &--disabled {
      opacity: 0.5;
    }
  }

  &__help-text {
    color: var(--website-card__reverse-background-color);
    font-size: 0.75rem;
    margin-top: space(0.125);
  }

  &__validation-error {
    color: var(--color__danger-s20);
    font-size: 0.75rem;
    margin-top: space(0.125);
  }

  &--has-errors {
    label {
      color: var(--color__danger-s20);
    }
    select ~ label,
    select:focus ~ label {
      @include asd20-focus;
    }
    input {
      border-color: var(--color__danger);
      &:focus {
        @include asd20-focus;
      }
    }
  }
}
</style>
